import React from 'react';
import moment from 'moment';

import { PastTransaction } from '../../../actions/ecomm-interfaces';
import Labels from '../../../resources/field-labels.json';

import { isMobile } from '../../../components/breakpoints';

export interface IHistoryCardProps {
  TransactionInfo: PastTransaction;
  OrderDateTitle: string;
  ReceiptTitle: string;
  SerialNumberText: string;
  Width: number;
  Locale: string;
}

/**
 *
 * ProductCard component
 * @extends {React.PureComponent<IHistoryCardProps>}
 */
 export class HistoryCard extends React.PureComponent<IHistoryCardProps> {
  public render(): JSX.Element | null {
    return (
      <li className={typeof this.props.Width !== 'undefined' && !isMobile(this.props.Width) ? 'desktop' : ''}>
        <div className='ecomm-history-card'>
          <div className='ecomm-history-card-product row'>
            <div className={typeof this.props.Width !== 'undefined' && !isMobile(this.props.Width) ? 'ecomm-history-card-product-info col-11' : 'ecomm-history-card-product-info col-12'}>
              <p className='ecomm-history-card-product-category'>{this.props.TransactionInfo.Record.ProductCategory}</p>
              
              <p className='ecomm-history-card-product-name'>{this.props.TransactionInfo.Record.ProductName}</p>
              
              {typeof this.props.TransactionInfo.Record.SerialNumber !== 'undefined' && this.props.TransactionInfo.Record.SerialNumber !== '' && <p className='ecomm-history-card-product-serial'>{this.props.SerialNumberText}: {this.props.TransactionInfo.Record.SerialNumber}</p>}
              
              {this._renderLampInfo()}
              
              {this.props.TransactionInfo.EventDates.length > 0 && <p className='ecomm-history-card-product-events'>{this.props.TransactionInfo.EventDates.join(', ')}</p>}
            </div>

            {typeof this.props.Width !== 'undefined' && !isMobile(this.props.Width) && <div className='ecomm-history-card-product-price col-1'>
              <p>${this.props.TransactionInfo.Record.ProductPrice.toFixed(2)}</p>
            </div>}
          </div>

          <div className='ecomm-history-card-content row'>
            {this._renderCategory()}

            {this._renderNames()}

            {this._renderDedicatedBy()}
            
            {this._renderMessage()}
            
            {this._renderBirthDateTime()}
            
            <p className='ecomm-history-card-content-date col-12'>{this.props.OrderDateTitle}: {moment(this.props.TransactionInfo.OrderDate).utc(false).format('DD MMM YYYY')}</p>
            
            {typeof this.props.Width !== 'undefined' && isMobile(this.props.Width) && <p className='ecomm-history-card-content-price col-12'>${this.props.TransactionInfo.Record.ProductPrice.toFixed(2)}</p>}
          </div>

          <hr className='row'/>

          <div className='ecomm-history-card-receipt row'>
            <p className="ecomm-history-card-receipt-title col-12">{this.props.ReceiptTitle}</p>
            {this.props.TransactionInfo.ReceiptNo.map((receipt => {
              return <p className="ecomm-history-card-receipt-number col-12">{receipt}</p>
            }))}
          </div>
        </div>
      </li>
    );
  }

  private _renderLampInfo(): JSX.Element | null {
    if (this.props.TransactionInfo.Record.LightOption && this.props.TransactionInfo.Record.LightOption !== '' && this.props.TransactionInfo.Record.ValidTo && this.props.TransactionInfo.Record.ValidTo !== '') {
      return <p className='ecomm-history-card-product-serial'>{moment(this.props.TransactionInfo.Record.ValidTo).utc(false).format('DD MMM YYYY')}</p>;
    }

    return null;
  }

  private _renderCategory(): JSX.Element | null {
    return this.props.TransactionInfo.Record.Category && this.props.TransactionInfo.Record.Category !== '' ? <p className='ecomm-history-card-content-category col-12'>{this.props.TransactionInfo.Record.Category}:</p> : null;
  }

  private _renderNames(): JSX.Element {
    const label = this.props.TransactionInfo.Record.DeathDate&&(!this.props.TransactionInfo.Record.DeathDate.includes('1900')) ? Labels.deceasedNames_Label[this.props.Locale] : Labels.displayNames_Label[this.props.Locale];    

    return <p className='col-12'>{label + ': ' + this.props.TransactionInfo.Names.join(', ')}</p>;
  }

  private _renderDedicatedBy(): JSX.Element | null {
    return this.props.TransactionInfo.Record.DedicatedBy && this.props.TransactionInfo.Record.DedicatedBy !== '' ? <p className='col-12'>{Labels.dedicatedBy_Label[this.props.Locale] + ': ' + this.props.TransactionInfo.Record.DedicatedBy}</p> : null;
  }

  private _renderMessage(): JSX.Element | null {
    return this.props.TransactionInfo.Record.Message && this.props.TransactionInfo.Record.Message !== '' ? <p className='col-12'>{Labels.message_Label[this.props.Locale] + ': ' + this.props.TransactionInfo.Record.Message}</p> : null;
  }

  private _renderBirthDateTime(): JSX.Element | null {
    const birthDate_1 = this.props.TransactionInfo.Record.BirthDate && !this.props.TransactionInfo.Record.BirthDate.includes('1900') ? <p className='col-12'>{Labels.birthDate_Label[this.props.Locale] + ': ' + moment.utc(this.props.TransactionInfo.Record.BirthDate).utcOffset(8 * 60).format('DD MMM YYYY')}</p> : null;
    return (
      <div>
        {birthDate_1}
      </div>
    );
  }
}

export default HistoryCard;